document.addEventListener('click', async function (e) {
    const btnModalEditarPersonal = e.target.closest('#btnModalEditarPersonal');
    if (!btnModalEditarPersonal) return;

    const idUsuario = btnModalEditarPersonal.getAttribute("data-id");
    const formEditar = document.querySelector("#formEditarPersonal");

    if (!formEditar || !idUsuario) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar información del personal.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const url = `/api/personal/infoUsuario?idUsuario=${idUsuario}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del usuario.", "alerta-roja");
            }
            return;
        }

        const inputIdUsuario = formEditar.querySelector('[name="idUsuario"]');
        const inputRol = formEditar.querySelector('[name="idRol"]');
        const inputCedula = formEditar.querySelector('[name="cedula"]');
        const inputNombre = formEditar.querySelector('[name="nombreUsuario"]');
        const inputApellido = formEditar.querySelector('[name="apellidoUsuario"]');
        const inputArea = formEditar.querySelector('[name="idArea"]');
        const inputZona = formEditar.querySelector('[name="idZona"]');
        const inputCargo = formEditar.querySelector('[name="idCargo"]');
        const inputFoto = formEditar.querySelector('[name="fotoActual"]');
        const previewFoto = formEditar.querySelector('.previewFotoColaborador');
        const estado = formEditar.querySelector('[name="estado"]');
        const checked = Number(data.estado) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estado) === 1 ? 'ACTIVO' : 'INACTIVO';
        const divShitch = formEditar.querySelector('#divShitch');

        if (inputIdUsuario) inputIdUsuario.value = data.idUsuario || "";
        if (inputRol) inputRol.value = data.idRol || 0;
        if (inputCedula) inputCedula.value = data.cedula || "";
        if (inputNombre) inputNombre.value = data.nombreUsuario || "";
        if (inputApellido) inputApellido.value = data.apellidoUsuario || "";
        if (inputArea) inputArea.value = data.idArea || 0;
        if (inputZona) inputZona.value = data.idZona || 0;
        if (inputCargo) inputCargo.value = data.idCargo || 0;
        const fotoSrc = data.fotoUsuario ? `/public/uploads/usuarios/${data.fotoUsuario}?v=${Date.now()}` : "";
        if (inputFoto) inputFoto.src = fotoSrc;
        if (previewFoto) previewFoto.src = fotoSrc;

        divShitch.innerHTML = `
            <div class="infoTercero">
                <span class="labelInfo">Estado:</span>
                <label class="switchEstado">
                    <input
                        id="estado" 
                        type="checkbox"
                        name="estado"
                        value="${data.estado}"
                        ${checked}
                    >
                    <span class="sliderEstado"></span>
                    <span class="textoEstado">
                        ${textoEstado}
                    </span>
                </label>
            </div>
        `;

    } catch (error) {
        console.error("Error al obtener información del usuario:", error);

        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del usuario.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {

    if (e.target.id === 'formEditarPersonal') {

        e.preventDefault();
        const formulario = e.target;
        const modalPadre = formulario.closest('.modal');
        const btnSubmit = formulario.querySelector('#btnEditarPersonal');
        const spinner = formulario.querySelector('#spinner');
        const formData = new FormData(formulario);
        
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/personal/editar', {
                method: 'POST',
                body: formData
            });
            
            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;
            
            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                window.location.href = "/personal";
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
            } 
            if (!resultado.hayErrores) {

                formulario.reset();
                
                if (modalPadre) modalPadre.classList.remove('modal--show');

                if (typeof window.actualizarTablaPersonal === 'function') {
                    window.actualizarTablaPersonal();
                }
                lanzarAlerta("Usuario editado correctamente.", "alerta-verde");
            }

        } catch (error) {
            console.error("Error:", error);
            window.location.href = "/personal";
            return;
        } finally {
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});